/**
 * Created by stonewang on 2017/9/8.
 */
import React from 'react';
import { Modal, Input } from 'antd';
import {TableView} from 'Components'
import PropTypes from 'prop-types';
import {getlistPcSpec} from '../../service/product'
const Search = Input.Search;


class ProductModal extends React.Component {
  state = {
    visible: false,
    text: '',
    rows: [],
    list: [],
    selectedRowKeys: [],
    selectItems: [],
    total: 0,
    searchObj: {
      kw: '',
      s: 10,
      p: 1,
    }
  };
  showModal = () => {
    this.setState({
      visible: true,
      text: '',
      rows: [],
      list: [],
      selectedRowKeys: [],
      selectItems: [],
      total: 0,
    }, () => {
      this.getData();
    });
  };
  getData = ()=>{
    const self = this;
    const {list} = this.state;
    getlistPcSpec(self.state.searchObj).then(res => {
      if(res.status){
        let tmp = res.data.map(x => {
          return {
            ...x,
            specId: x.specId || `specId${Math.random()}`
          }
        });
        self.setState({rows: tmp, total:res.total, list:[...list, ...tmp]});
      }else{
        console.error(res.message);
      }
    })
  };
  handleOk = (e) => {
    let arr = [];
    const {selectedRowKeys, list} = this.state;
    // console.log(selectedRowKeys);
    selectedRowKeys.forEach(item => {
      const i = list.findIndex( x => x.specId === item);
      if(i !== -1){
        arr.push(list[i])
      }
    });
    /*const tmp = arr.map(x => {
      return {
        ...x,
        specId: x.specId.toString().match('specId') ? '' :  x.specId
      }
    });*/
    this.setState({visible: false, selectItems: arr}, ()=>{
      if(this.props.onOk){
        this.props.onOk(arr);
      }
    });
  };
  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  changeHandle = (val) => {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, kw:val, p: 1 } }, ()=>{
      self.getData()
    });
  };
  onSelectChange = (selectedRowKeys) => {
    this.setState({selectedRowKeys});
  };
  pageChange = (page, pageSize) => {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  };
  render () {
    const {rows, searchObj, total, selectedRowKeys} = this.state;
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'specId',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
        }, {
          title: '规格',
          dataIndex: 'specUnionKey',
        }, {
          title: '类别',
          dataIndex: 'categoryText'
        }, {
          title: '单位',
          dataIndex: 'unitText',
        }
      ],
      rows,
      rowSelection: {
        selectedRowKeys,
        onChange: this.onSelectChange
      }
    };
    return <Modal
      width={800}
      title="选择产品"
      visible={this.state.visible}
      onOk={this.handleOk}
      onCancel={this.handleCancel}
    >
      <Search
        placeholder="请输入产品名称"
        style={{ width: 200 }}
        onSearch={this.changeHandle}
      />
      <div className="dms-split-bar"></div>
      <TableView {...tableViewProps} />
    </Modal>
  }
}
ProductModal.propTypes = {
  onOk: PropTypes.func,
};
export default ProductModal;


// WEBPACK FOOTER //
// ./src/routes/inventory/productModal.js